import AbstractPeriodColumnSource from "./AbstractPeriodColumnSource.js";

/**
 * This class is used when a period column should fetch data from a
 * forecast estimate.
 *
 * @param {string} forecastEstimateId - A unique identifier for the
 *   forecast estimate being used as source of data for the period column
 */
export default class ForecastEstimatePeriodColumnSource extends AbstractPeriodColumnSource {
	constructor({ forecastEstimateId }) {
		super(...arguments);

		this._forecastEstimateId = forecastEstimateId;
	}

	isForecastEstimateSource() {
		return true;
	}

	getForecastEstimateId() {
		return this._forecastEstimateId;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.forecastEstimateId = this._forecastEstimateId;

		return properties;
	}
}
